<template>
   <!-- EMAIL INTEGRATION SLIDER -->

   <!-- EMAIL HEADLINES -->

   <section
      class="mx-auto mt-[145px] max-w-[1140px] px-[25px] text-center xl:px-0"
   >
      <div class="text-left">
         <div
            id="text_email_integrations"
            class="text-xs font-bold tracking-wide text-[#2D8CFF]"
         >
            EMAIL INTEGRATIONS
         </div>

         <h2
            class="px-auto top-full mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
         >
            Unite your CRM with Platforma
         </h2>

         <p
            class="mt-[20px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-full"
         >
            Platforma integrates with your favorite tools, and we’re adding more
            every week!
         </p>

         <div class="mt-[15px] justify-between py-[10px] px-[10px] md:flex">
            <div class="flex justify-between">
               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/aweber-email-marketing-platforma-integrations.png'
                        )
                     "
                     alt=""
                     class=""
                  />
               </div>

               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/mailchimp-email-marketing-platforma-integrations.png'
                        )
                     "
                     alt=""
                  />
               </div>

               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/mailerlite-email-marketing-platforma-integrations.png'
                        )
                     "
                     alt=""
                  />
               </div>

               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/drip-platforma-integration.png'
                        )
                     "
                     alt=""
                  />
               </div>

               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/constantcontact-email-marketing-platforma-integrations.png'
                        )
                     "
                     alt=""
                  />
               </div>
            </div>

            <div class="mt-[10px] flex justify-between md:mt-0">
               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/activecampaign-email-marketing-platforma-integrations.png'
                        )
                     "
                     alt=""
                  />
               </div>

               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/getresponse-platforma-integration.png'
                        )
                     "
                     alt=""
                  />
               </div>

               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/sendinblue-platforma-integration.png'
                        )
                     "
                     alt=""
                  />
               </div>

               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/sendgrid-email-marketing-platforma-integrations.png'
                        )
                     "
                     alt=""
                  />
               </div>

               <div
                  class="mr-[10px] h-[65px] cursor-pointer rounded-lg bg-white py-[25px] px-[5px] shadow-lg delay-100 duration-500 ease-in-out hover:scale-105 lg:py-[20px]"
               >
                  <img
                     :src="
                        $filters.media_path(
                           '/images/hubspot-platforma-integration.png'
                        )
                     "
                     alt=""
                  />
               </div>
            </div>
         </div>
         <a href="/integrations">
            <button
               class="my-[25px] h-[50px] w-[210px] rounded-[4px] bg-[#2d8bff] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
            >
               View All Integrations
            </button>
         </a>
      </div>
   </section>
</template>

<script></script>

<style></style>
